const RUNTIME_SHIM_SPECIFIER_PATTERN = /^\/__mutiny\/runtime\/([\w-]+)\/([\w.-]+)\.js$/;

// The compiler only emits registry-allowlisted slugs and versions, so this remains a pure path
// transform. An unknown but well-formed slug will fail when the matching asset returns 404.
export function buildRuntimeShimPath(specifier: string): string {
  const match = specifier.match(RUNTIME_SHIM_SPECIFIER_PATTERN);
  if (!match) {
    throw new Error(`Unsupported custom-component runtime specifier: ${specifier}`);
  }
  const [, slug, version] = match;
  return `/assets/mutiny-runtime-${slug}-${version}.js`;
}

/**
 * Whether a static-assets base can host artifact URLs. `staticAssetsBaseURL` crosses the
 * postMessage INIT_SNAPSHOT boundary (editor canvas) and the GraphQL data boundary (published
 * pages), so it arrives unvalidated: interpolating an absent value produced production fetches
 * to `https://undefined/...` / `https://null/...`. Builders below return `null` for an unusable
 * base and callers must skip the load instead of fetching.
 */
export function isStaticAssetsBaseUrlUsable(base: string | null | undefined): base is string {
  return typeof base === 'string' && base.length > 0;
}

export function buildCompiledAssetUrl(
  staticAssetsBaseURL: string | null | undefined,
  sourceHash: string,
): string | null {
  if (!isStaticAssetsBaseUrlUsable(staticAssetsBaseURL)) return null;
  return `https://${staticAssetsBaseURL}/assets/${sourceHash}.js`;
}

export function buildRuntimeShimUrl(staticAssetsBaseURL: string | null | undefined, specifier: string): string | null {
  if (!isStaticAssetsBaseUrlUsable(staticAssetsBaseURL)) return null;
  return `https://${staticAssetsBaseURL}${buildRuntimeShimPath(specifier)}`;
}
